module.exports = __webpack_public_path__ + "static/img/douaho_h.bba9e679.png";